import * as types from '../constants/idpAdminActions';
import {
  addSpApi,
  deleteAppApi,
  deleteAppsApi,
  getAppApi,
  importFromXmlApi,
  importUrlApi,
  updateAppApi
} from "../api/api";
import {USER_DISPLAY_NAME} from '../constants/samlConstants';
import {
  ADD_SP_METADATA_SAVED,
  ANY_ORIGIN,
  AUTH_SESSION_TOKEN,
  CANCEL_ADD_SAML,
  DELETE_APP_FAIL,
  DELETE_APP_OK
} from "../constants/postMessages";

export const importUrlStart = () => ({
  type: types.PARSE_FROM_URL_START
});
export const importUrlSuccess = (metadata) => ({
  type: types.PARSE_FROM_URL_SUCCESS,
  metadata,
});
export const importUrlFail = (errorMsg) => ({
  type: types.PARSE_FROM_URL_FAIL,
  errorMsg,
});

export function importUrl(parseUrl) {
  return (dispatch) => {
    dispatch(importUrlStart());
    return importUrlApi(parseUrl)
    .then(response => {
      dispatch(importUrlSuccess(response));
    })
    //Handle errors
    .catch(error => {
      return error.response.json().then(r => {
        //Handle a specific error when there are no valid certificates
        if (r.errorMessage === "SP_METADATA_NO_VALID_CERTIFICATES") {
          dispatch(showModalExpiredMetadataCertificate())
        }
        else {
          dispatch(importXmlFail());
        }
      }).catch(error => dispatch(importXmlFail()));
    })
  }
}

export const importXmlStart = () => ({
  type: types.PARSE_FROM_XML_START
});
export const importXmlSuccess = (metadata) => ({
  type: types.PARSE_FROM_XML_SUCCESS,
  metadata,
});
export const importXmlFail = (errorMsg) => ({
  type: types.PARSE_FROM_XML_FAIL,
  errorMsg,
});

export const clearImportUrl = () => ({
  type: types.CLEAR_IMPORT_URL
});

export const addSpStart = () => ({
  type: types.ADD_SP_START
});
export const addSpSuccess = () => ({
  type: types.ADD_SP_SUCCESS
});
export const addSpFail = (errorMsg) => ({
  type: types.ADD_SP_FAIL,
  errorMsg,
});

export function addSp(metadata) {
  return (dispatch) => {
    const newMeta = {
      "name": metadata.name,
      "userFriendlyName": metadata.userFriendlyName,
      "spSaml2Metadata": metadata.spSaml2Metadata
    };
    dispatch(addSpStart());
    return addSpApi(newMeta)
    .then(response => {
      dispatch(addSpSuccess());
      window.parent.postMessage(ADD_SP_METADATA_SAVED, ANY_ORIGIN);
    })
    .catch((error) => dispatch(addSpFail(error.message)));
  }
}

export const updateAppStart = () => ({
  type: types.UPDATE_APPLICATION_START
});
export const updateAppSuccess = () => ({
  type: types.UPDATE_APPLICATION_SUCCESS
});
export const updateAppFail = (errorMsg) => ({
  type: types.UPDATE_APPLICATION_FAIL,
  errorMsg,
});

export function updateApp(metadata) {
  return (dispatch) => {
    const newMeta = {
      "name": metadata.name,
      "userFriendlyName": metadata.userFriendlyName,
      "spSaml2Metadata": metadata.spSaml2Metadata,
      "applicationId": metadata.applicationId
    };
    dispatch(updateAppStart());
    return updateAppApi(metadata.applicationId, newMeta)
    .then(function () {
      dispatch(updateAppSuccess());
      window.parent.postMessage(ADD_SP_METADATA_SAVED, ANY_ORIGIN);
    })
    .catch((error) => {
      dispatch(updateAppFail(error.message))
    });
  }
}

export const getAppStart = () => ({
  type: types.GET_APPLICATION_START
});
export const getAppSuccess = (metadata) => ({
  type: types.GET_APPLICATION_SUCCESS,
  metadata,
});
export const getAppFail = (errorMsg) => ({
  type: types.GET_APPLICATION_FAIL,
  errorMsg,
});

export function getApp(applicationId) {
  return (dispatch) => {
    dispatch(getAppStart());
    return getAppApi(applicationId)
    .then(response => {
      dispatch(getAppSuccess(response));
    })
    .catch((error) => {
      dispatch(getAppFail(error.message));
    });
  }
}

export function importFromXml(file) {
  const data = new FormData();
  data.append("SpMetadataXml", file);
  return (dispatch) => {
    dispatch(importXmlStart());
    return importFromXmlApi(data)
    .then(response => {
      dispatch(importXmlSuccess(response));
    })
    //Handle errors
    .catch(error => {
      return error.response.json().then(r => {
        //Handle a specific error when there are no valid certificates
        if (r.errorMessage === "SP_METADATA_NO_VALID_CERTIFICATES") {
          dispatch(showModalExpiredMetadataCertificate())
        }
        else {
          dispatch(importXmlFail());
        }
      }).catch(error => dispatch(importXmlFail()));
    })
  }
}

export function deleteApp(applicationIds) {
  return (dispatch) => {
    if (sessionStorage.getItem("authSessionToken")) {
      dispatch(deleteAppStart());
      const arrAppIds = applicationIds.split(',').filter((appId) => {
        return appId !== "";
      });
      let count = 0;
      arrAppIds.forEach((appId) => {
        deleteAppApi(appId)
        .then(response => {
          if (response.status !== 404 && response.status !== 200) {
            dispatch(deleteAppFail());
            window.parent.postMessage(DELETE_APP_FAIL, ANY_ORIGIN);
          } else if (++count === arrAppIds.length) {
            dispatch(deleteAppSuccess());
            window.parent.postMessage(DELETE_APP_OK, ANY_ORIGIN);
          }
        })
        .catch((error) => {
          dispatch(deleteAppFail(error.message));
          window.parent.postMessage(DELETE_APP_FAIL, ANY_ORIGIN);
        });
      });
    }
  }
}

export function deleteApps(applicationIds) {
  return (dispatch) => {
    if (sessionStorage.getItem(AUTH_SESSION_TOKEN)) {
      dispatch(deleteAppStart());
      let arrAppIds = applicationIds.split(',').filter((appId) => {
        return appId !== "";
      })
      const appIds = {
        "applications": arrAppIds
      }
      deleteAppsApi(appIds)
      .then(response => {
        if (response.status !== 200) {
          throw new Error("Application deleting fail");
        } else {
          return response.json();
        }
      })
      .then(response => {
        //From back-end we receive response, which contains object like
        // "{ 123: true, 345: true, 33: false}".
        // Using "for .. in" we check each field in this object.
        // If all fields are "true" we will send "delete_app_ok" to appliance,
        // but if we meet at least one field which is "false" we will send "delete_app_fail"
        for (let key in response) {
          if (!response[key]) {
            //After this command will be executed catch block
            throw new Error("Application deleting fail");
          }
        }
        dispatch(deleteAppSuccess());
        window.parent.postMessage(DELETE_APP_OK, ANY_ORIGIN);
      })
      .catch((error) => {
        dispatch(deleteAppFail(error.message));
        window.parent.postMessage(DELETE_APP_FAIL, ANY_ORIGIN);
      });
    }
  }
}

export const deleteAppStart = () => ({
  type: types.DELETE_SP_START
});
export const deleteAppSuccess = () => ({
  type: types.DELETE_SP_SUCCESS,
});
export const deleteAppFail = (errorMsg) => ({
  type: types.DELETE_SP_FAIL,
  errorMsg,
});

export function cancelAddSaml() {
  window.parent.postMessage(CANCEL_ADD_SAML, ANY_ORIGIN);
  return {
    type: types.CANCEL_ADD_APPLICATION
  }
}

export const addUserAttributeConst = (newUserAttribute) => ({
  type: types.ADD_USER_ATTRIBUTE,
  newUserAttribute
});

export const deleteUserAttributeConst = (targetAttribute) => ({
  type: types.DELETE_USER_ATTRIBUTE,
  targetAttribute
});

export const updateUserAttributesConst = (payload) => ({
  type: types.UPDATE_USER_ATTRIBUTES,
  payload
});

export const recoverAppConst = (payload) => ({
  type: types.RECOVER_APPLICATION,
  payload
});

export const replaceAppConst = (payload, appId) => ({
  type: types.REPLACE_APPLICATION,
  payload,
  appId
});

export function deleteUserAttribute(target) {
  return (dispatch) => {
    dispatch(deleteUserAttributeConst(target));
  }
}

export function addUserAttribute() {
  return (dispatch) => {
    let newUserAttribute = {
      'userAttributeName': "",
      'idpUserAttributeEnum': USER_DISPLAY_NAME,
      'userSpecifiedValue': "",
    }
    dispatch(addUserAttributeConst(newUserAttribute));
  }
}

export function updateUserAttributes(evt) {
  return (dispatch) => {
    dispatch(updateUserAttributesConst(evt));
  }
}

export function recoverApp(payload) {
  return (dispatch) => {
    dispatch(recoverAppConst(payload));
  }
}

export function replaceApp(payload, appId) {
  return (dispatch) => {
    dispatch(replaceAppConst(payload, appId));
  }
}

export const clearErrorMessage = () => ({
  type: types.CLEAR_ERROR_MESSAGE
});

export const updateAppNameConst = (payload) => ({
  type: types.UPDATE_APP_NAME,
  payload
});

export function updateAppName(payload) {
  return (dispatch) => {
    dispatch(updateAppNameConst(payload));
  }
}

export const updateUserFriendlyNameConst = (payload) => ({
  type: types.UPDATE_USER_FRIENDLY_NAME,
  payload
});

export function updateUserFriendlyName(payload) {
  return (dispatch) => {
    dispatch(updateUserFriendlyNameConst(payload));
  }
}

export const updateDefaultNameIdConst = (payload) => ({
  type: types.UPDATE_DEFAULT_NAME_ID,
  payload
});

export function updateDefaultNameId(payload) {
  return (dispatch) => {
    dispatch(updateDefaultNameIdConst(payload));
  }
}

export const clearMessages = () => ({
  type: types.CLEAR_MESSAGES,
});

export const setErrorMessage = (errorMsg) => ({
  type: types.SET_ERROR_MESSAGE,
  errorMsg
});

export const updateDownloadUrlConst = (payload) => ({
  type: types.UPDATE_DOWNLOAD_URL,
  payload
});

export function updateDownloadUrl(payload) {
  return (dispatch) => {
    dispatch(updateDownloadUrlConst(payload));
  }
}

export const showImportModalPopupConst = () => ({
  type: types.SHOW_IMPORT_MODAL,
});
export const hideImportModalPopupConst = () => ({
  type: types.HIDE_IMPORT_MODAL,
});

export function showImportModalPopup() {
  return (dispatch) =>
      dispatch(showImportModalPopupConst());
}

export function hideImportModalPopup() {
  return (dispatch) =>
      dispatch(hideImportModalPopupConst());
}

export const showModalViewAllMetadataConst = () => ({
  type: types.SHOW_ALL_METADATA_MODAL,
});
export const hideModalViewAllMetadataConst = () => ({
  type: types.HIDE_ALL_METADATA_MODAL,
});

export function showModalViewAllMetadata() {
  return (dispatch) =>
      dispatch(showModalViewAllMetadataConst());
}

export function hideModalViewAllMetadata() {
  return (dispatch) =>
      dispatch(hideModalViewAllMetadataConst());
}

export const showModalExpiredMetadataCertificateConst = () => ({
  type: types.SHOW_EXPIRED_METADATA_CERTIFICATE_MODAL,
});
export const hideModalExpiredMetadataCertificateConst = () => ({
  type: types.HIDE_EXPIRED_METADATA_CERTIFICATE_MODAL,
});

export function showModalExpiredMetadataCertificate() {
  return (dispatch) =>
      dispatch(showModalExpiredMetadataCertificateConst());
}

export function hideModalExpiredMetadataCertificate() {
  return (dispatch) =>
      dispatch(hideModalExpiredMetadataCertificateConst());
}

export const changeSelectedImportOptionConst = (payload) => ({
  type: types.CHANGE_SELECTED_IMPORT_OPTION,
  payload
});

export function changeSelectedImportOption(payload) {
  return (dispatch) =>
      dispatch(changeSelectedImportOptionConst(payload));
}



// WEBPACK FOOTER //
// ./src/actions/sp.js